import { Chip, Stack } from '@mui/material';
import { useEffect } from 'react';
import { useFragmentTagGroups } from '../../../hooks/useFragmentTagGroups';
import { useFragmentForm } from '../useFragmentForm';

export function FragmentTagGroupsSelector() {
  const { watch, setValue } = useFragmentForm();
  const stationId = watch('stationId');
  const tags = watch('tags') || [];
  const tagGroups = useFragmentTagGroups(stationId);

  useEffect(() => {
    if (!tagGroups.length) return;
    const hasTags = tags.length > 0;
    if (hasTags) return;
    const defaultGroup = tagGroups.find((g) => g.default);
    if (defaultGroup?.tags.length) {
      setValue('tags', defaultGroup.tags);
    }
  }, []);

  if (!tagGroups.length) return null;

  return (
    <Stack direction="row" flexWrap="wrap" gap={0.75} mt={0.5}>
      {tagGroups.map((group) => (
        <Chip
          key={group.name}
          label={`+ ${group.name}`}
          size="small"
          variant="outlined"
          onClick={() => setValue('tags', group.tags)}
          sx={{ cursor: 'pointer' }}
        />
      ))}
    </Stack>
  );
}
